var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.app.maintenance_enabled)?_c('v-banner',{staticClass:"maintenance-notification title",staticStyle:{"z-index":"1000000"},attrs:{"color":"error","sticky":""}},[_c('span',{staticClass:"text"},[_vm._v(" The site is under maintenance. Please try again later. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }